<template>
  <ul class="plansList">
    <li v-for="(subscription, index) in safeSubscriptions" :id="`sub${index}`" :key="`sub${index}`">
      <span v-if="isOnlyKeycode(subscription)">
        <strong>{{ subscription.productDisplayName }}</strong>
        ({{ t("keycode") }}:
        <strong>{{ displayKeycode(subscription?.keyCode ?? "") }})</strong>
      </span>
      <span v-else>
        <div v-if="computerName(subscription)">
          <strong>{{ subscription.productDisplayName }}</strong>
          {{ t("SubscriptionInformationComponent.on") }}
          <span class="computer-name">
            <strong>{{ computerName(subscription) }}</strong>
          </span>
        </div>
        <div v-else>
          <strong>{{ subscription.productDisplayName }}</strong>
          ({{ t("SubscriptionInformationComponent.unassigned") }})
        </div>
      </span>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from "vue";
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";
import { ISubscription } from "@/common/api/unifiedPortal/interfaces";
import { KeyCodeSeller } from "@/globalEnums";
import { formatKeycode } from "@/common/formatKeycode";
import { carboniteProducts } from "@/common/productsBySku";

const componentName = "SafeProductsInfoComponent";

export default defineComponent({
  name: componentName,

  props: {
    subscriptions: {
      type: Array as PropType<ISubscription[]>,
      required: true,
    },
  },

  setup(props) {
    logEvent("created", componentName);

    const safeSubscriptions = computed(() => {
      return props.subscriptions.filter(sub => sub.keyCodeSellerType === KeyCodeSeller.Safe && sub.isAutoRenewEnabled);
    });

    function computerName(subscription: ISubscription) {
      return subscription.computer?.description ?? subscription.computer?.name;
    }

    function displayKeycode(keycode: string): string {
      return formatKeycode(keycode);
    }

    function isOnlyKeycode(subscription: ISubscription) {
      return (
        subscription.keyCode &&
        subscription.sku &&
        carboniteProducts.filter(product => product.sku === subscription.sku).length === 0
      );
    }

    //Expose to template
    return { t, safeSubscriptions, computerName, displayKeycode, isOnlyKeycode };
  },
});
</script>

<style scoped lang="css">
@import "@/styles/variables.css";

.plansList {
  list-style-type: disc;
  padding-left: var(--space);
}

.computer-name {
  max-width: 200px;
  display: flex;
}

.computer-name strong {
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
